import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="copyright">
        Copyright<span>&copy;</span> Nimisha Thallapally. All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
